// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Miltonian&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::after, *::before {
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
}

html,
body {
  min-width: fit-content;
  min-height: 100vh;
}

body {
  overflow-y: scroll;

  background-color: #000;
  background-image: url('/img/blackboard-texture.png');
  background-position: center;
}

#main-container {
  min-height: 100vh;
  min-width: 100vw;
  max-width: 100vw;
}

a, a:hover, a:active, a:visited {
  text-decoration: none;
  color: #eee;
}

a:hover, a:active {
  text-decoration: underline;
}

body,
input,
textarea,
select,
button {
  font-family: 'Merriweather', serif;
  font-weight: 300;
  letter-spacing: 0.03em;
  font-size: 16px;
  line-height: 1.42em;

  color: #eee;
}

select,
button {
  min-width: 42px;
  padding: 6px 12px;

  border: none;
  border-radius: 4px;

  cursor: pointer;
}

select {
  background: #444;
  border-right: solid 6px #444;
  height: 34px;
}

button {
  background: #060;
}

button.button-secondary {
  background: transparent;
  text-decoration: underline;
  color: #888;
}

label {
  color: #888;
  user-select: none;
}

.op-flex,
.op-flex > * {
    --op-flex-gap-vertical: 42px;
    --op-flex-gap-horizontal: 42px;
}

.main-header {
  width: 100%;
  padding-top: 100px;

  overflow: hidden;
}

#main-logo {
  position: fixed;
  top: -33px;

  min-width: 180px;
  max-width: 180px;

  transition: transform 5ms linear;

  z-index: 99999;
}

.link-bar {
  width: 100%;
  min-height: 100px;
  padding: 42px 10px;

  font-family: 'Miltonian', cursive;
  font-size: 1.4em;
  text-align: center;
}

.link-bar * {
  min-width: 170px;
}

.top-bar {
  position: fixed;
  top: 0px;
  box-shadow: 0px 4px 4px 0px rgba(10, 10, 10, 0.7);
}

.logo-back {
  min-width: 620px;
  max-width: 100%;
  min-height: 380px;
  max-height: 380px;
}

@media (max-width: 481px) {
  .top-bar {
    position: absolute;
  }

  .logo-back {
    visibility: hidden;
  }
}

.over-bar,
.under-bar,
.footer-bar {
  width: 100%;
  padding: 0px 20px;
  text-align: center;
}

.under-bar > .op-flex > span,
.footer-bar > .op-flex > span {
  min-width: 200px;
}

.over-bar {
  margin-top: 24px;
}

.under-bar {
  margin-bottom: 24px;
}

.footer-bar {
  margin-bottom: 84px;
}

.footer-bar * {
  min-width: 170px;
}


.product-box {
  width: 330px;
  height: 420px;
}

.product-box > * {
    --op-flex-gap-vertical: 21px;
    --op-flex-gap-horizontal: 21px;
}

.product-box .product-img {
  width: 200px;
  height: 200px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  border-radius: 10px;
}

.product-box .product-price {
  font-size: 1.1em;
  font-weight: 700;

  padding: 3px 6px;
  border: dashed 1px #ccc;
  border-radius: 3px;
  background: #400e0e;
}


.fancy-title {
  min-height: 32px;
  line-height: 32px;
  padding-left: 120px;
  padding-right: 120px;

  background-image: url('/img/title-end-left.png'), url('/img/title-end-right.png');
  background-position: left, right;
  background-size: 90px, 90px;
  background-repeat: no-repeat, no-repeat;

  text-align: center;
}

.fancy-box-1,
.fancy-box-2 {
  padding: 42px 20px;
  background-image: url('/img/border-top-left.png'), url('/img/border-top-right.png'), url('/img/border-bottom-left.png'), url('/img/border-bottom-right.png'), url('/img/border-top.png'), url('/img/border-bottom.png'), url('/img/border-left.png'), url('/img/border-right.png'), url('/img/blackboard-texture.png');
  background-position: top left, top right, bottom left, bottom right, top, bottom, left, right, center;
  background-size: 30px, 30px, 30px, 30px, 165px, 165px, 10px, 10px, auto;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, repeat-x, repeat-x, repeat-y, repeat-y, repeat;
}

.fancy-box-2 {
  background-image: url('/img/border-top-left-2.png'), url('/img/border-top-right-2.png'), url('/img/border-bottom-left-2.png'), url('/img/border-bottom-right-2.png'), url('/img/border-top-2.png'), url('/img/border-bottom-2.png'), url('/img/border-left-2.png'), url('/img/border-right-2.png'), url('/img/blackboard-texture.png');
}
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,sBAAsB;EACtB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;EAKE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,iBAAiB;;EAEjB,YAAY;EACZ,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;IAEI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;;EAEV,gBAAgB;EAChB,gBAAgB;;EAEhB,gCAAgC;;EAEhC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;EAElB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;;EAEhB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;;EAEpB,iFAAiF;EACjF,gCAAgC;EAChC,2BAA2B;EAC3B,uCAAuC;;EAEvC,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,sTAAsT;EACtT,qGAAqG;EACrG,uEAAuE;EACvE,6GAA6G;AAC/G;;AAEA;EACE,sUAAsU;AACxU","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Miltonian&display=swap');\n\n*, *::after, *::before {\n  box-sizing: border-box;\n  padding: 0px;\n  margin: 0px;\n}\n\nhtml,\nbody {\n  min-width: fit-content;\n  min-height: 100vh;\n}\n\nbody {\n  overflow-y: scroll;\n\n  background-color: #000;\n  background-image: url('/img/blackboard-texture.png');\n  background-position: center;\n}\n\n#main-container {\n  min-height: 100vh;\n  min-width: 100vw;\n  max-width: 100vw;\n}\n\na, a:hover, a:active, a:visited {\n  text-decoration: none;\n  color: #eee;\n}\n\na:hover, a:active {\n  text-decoration: underline;\n}\n\nbody,\ninput,\ntextarea,\nselect,\nbutton {\n  font-family: 'Merriweather', serif;\n  font-weight: 300;\n  letter-spacing: 0.03em;\n  font-size: 16px;\n  line-height: 1.42em;\n\n  color: #eee;\n}\n\nselect,\nbutton {\n  min-width: 42px;\n  padding: 6px 12px;\n\n  border: none;\n  border-radius: 4px;\n\n  cursor: pointer;\n}\n\nselect {\n  background: #444;\n  border-right: solid 6px #444;\n  height: 34px;\n}\n\nbutton {\n  background: #060;\n}\n\nbutton.button-secondary {\n  background: transparent;\n  text-decoration: underline;\n  color: #888;\n}\n\nlabel {\n  color: #888;\n  user-select: none;\n}\n\n.op-flex,\n.op-flex > * {\n    --op-flex-gap-vertical: 42px;\n    --op-flex-gap-horizontal: 42px;\n}\n\n.main-header {\n  width: 100%;\n  padding-top: 100px;\n\n  overflow: hidden;\n}\n\n#main-logo {\n  position: fixed;\n  top: -33px;\n\n  min-width: 180px;\n  max-width: 180px;\n\n  transition: transform 5ms linear;\n\n  z-index: 99999;\n}\n\n.link-bar {\n  width: 100%;\n  min-height: 100px;\n  padding: 42px 10px;\n\n  font-family: 'Miltonian', cursive;\n  font-size: 1.4em;\n  text-align: center;\n}\n\n.link-bar * {\n  min-width: 170px;\n}\n\n.top-bar {\n  position: fixed;\n  top: 0px;\n  box-shadow: 0px 4px 4px 0px rgba(10, 10, 10, 0.7);\n}\n\n.logo-back {\n  min-width: 620px;\n  max-width: 100%;\n  min-height: 380px;\n  max-height: 380px;\n}\n\n@media (max-width: 481px) {\n  .top-bar {\n    position: absolute;\n  }\n\n  .logo-back {\n    visibility: hidden;\n  }\n}\n\n.over-bar,\n.under-bar,\n.footer-bar {\n  width: 100%;\n  padding: 0px 20px;\n  text-align: center;\n}\n\n.under-bar > .op-flex > span,\n.footer-bar > .op-flex > span {\n  min-width: 200px;\n}\n\n.over-bar {\n  margin-top: 24px;\n}\n\n.under-bar {\n  margin-bottom: 24px;\n}\n\n.footer-bar {\n  margin-bottom: 84px;\n}\n\n.footer-bar * {\n  min-width: 170px;\n}\n\n\n.product-box {\n  width: 330px;\n  height: 420px;\n}\n\n.product-box > * {\n    --op-flex-gap-vertical: 21px;\n    --op-flex-gap-horizontal: 21px;\n}\n\n.product-box .product-img {\n  width: 200px;\n  height: 200px;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  border-radius: 10px;\n}\n\n.product-box .product-price {\n  font-size: 1.1em;\n  font-weight: 700;\n\n  padding: 3px 6px;\n  border: dashed 1px #ccc;\n  border-radius: 3px;\n  background: #400e0e;\n}\n\n\n.fancy-title {\n  min-height: 32px;\n  line-height: 32px;\n  padding-left: 120px;\n  padding-right: 120px;\n\n  background-image: url('/img/title-end-left.png'), url('/img/title-end-right.png');\n  background-position: left, right;\n  background-size: 90px, 90px;\n  background-repeat: no-repeat, no-repeat;\n\n  text-align: center;\n}\n\n.fancy-box-1,\n.fancy-box-2 {\n  padding: 42px 20px;\n  background-image: url('/img/border-top-left.png'), url('/img/border-top-right.png'), url('/img/border-bottom-left.png'), url('/img/border-bottom-right.png'), url('/img/border-top.png'), url('/img/border-bottom.png'), url('/img/border-left.png'), url('/img/border-right.png'), url('/img/blackboard-texture.png');\n  background-position: top left, top right, bottom left, bottom right, top, bottom, left, right, center;\n  background-size: 30px, 30px, 30px, 30px, 165px, 165px, 10px, 10px, auto;\n  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, repeat-x, repeat-x, repeat-y, repeat-y, repeat;\n}\n\n.fancy-box-2 {\n  background-image: url('/img/border-top-left-2.png'), url('/img/border-top-right-2.png'), url('/img/border-bottom-left-2.png'), url('/img/border-bottom-right-2.png'), url('/img/border-top-2.png'), url('/img/border-bottom-2.png'), url('/img/border-left-2.png'), url('/img/border-right-2.png'), url('/img/blackboard-texture.png');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
